// extracted by mini-css-extract-plugin
export default {"InviteAdminContainer":"InviteAdminForm_InviteAdminContainer__M7ImA","ButtonContainer":"InviteAdminForm_ButtonContainer__EFFh7","SubmitButton":"InviteAdminForm_SubmitButton__tvPjK"};